import { AdministrationView as BaseAdministrationView } from 'modules/administration/common/views';

import { FormFooter } from '../../common/components/FormFooter';
import {
  OnboardingSettingsForm,
  OnboardingSettingsActions,
  OnboardingSettingsFormContent,
  OnboardingSettingsFormProps,
} from '../components';

interface Props extends OnboardingSettingsFormProps {
  submitLoading?: boolean;
}

export const OnboardingSettingsView = ({
  initialValues,
  submitLoading,
  onSubmit,
}: Props) => (
  <OnboardingSettingsForm initialValues={initialValues} onSubmit={onSubmit}>
    <BaseAdministrationView
      headerRightContent={<OnboardingSettingsActions />}
      tabValue="onboarding"
    >
      <OnboardingSettingsFormContent />
      <FormFooter submitLoading={submitLoading} />
    </BaseAdministrationView>
  </OnboardingSettingsForm>
);
